export default __webpack_public_path__ + "61b6757571f687faea8e32518c5aa1b4.svg";